import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  userDetails = null;
  creditCard = null;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    /*********get user details in resolver*********/
    let resolverUserDetails = this.route.snapshot.data.userDetails;
    if(resolverUserDetails['response']['status'] === 1) {
      this.userDetails = resolverUserDetails['response']['data']['users'];
    }
    /********************END*********************/
    /***********get credit card list**************/
    this.apiService.getCreditCardList().subscribe(data => {
      if(data['response']['status'] === 1) {
        let creditCards = data['response']['data']['credit_cards'];
        for(let card of creditCards) {
          if(card.default == true) {
            this.creditCard = card;
          }
        }
      }
    }, err => {
      console.log(err)
    });
    /********************END*********************/
  }

}
